import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import theme from "../../../theme";

const SearchBar = ({ placeholder, Icon, onChange, sx }) => {
  return (
    <TextField
      variant="outlined"
      placeholder={placeholder}
      onChange={onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon sx={{ color: theme.colors.themeColor }} />
          </InputAdornment>
        ),
        sx: sx,
      }}
      inputProps={{
        style: {
          padding: "5px",
        },
      }}
    />
  );
};

export default SearchBar;
